import { LineOfCreditHistoryDetailsSuccess } from '@varo/graphql-schema-types';
import { useRouter } from 'expo-router';
import { useCallback } from 'react';
import FetchLineOfCreditHistoryDetails from 'services/graphql/queries/FetchLineOfCreditHistoryDetails';
import { useDefaultErrorStrings } from 'shared/hooks/errorFormatters/useDefaultError/useDefaultErrorStrings';
import { ErrorScreenType } from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';
import { useQuery } from 'urql';

interface VlocHistoryTypes {
  vlocData?: LineOfCreditHistoryDetailsSuccess;
  errorModel?: {
    screenType: ErrorScreenType;
    messageHeadline: string;
    messageBody: string;
    primaryButton: {
      title: string;
      onPress: () => void;
    };
  } | null;
  loading: boolean;
  refetch: () => void;
}

const useVlocHistoryDetails = (vlocId: string): VlocHistoryTypes => {
  const router = useRouter();
  const [{ data, error, fetching }, executeQuery] = useQuery<{
    lineOfCreditHistoryDetails: LineOfCreditHistoryDetailsSuccess;
  }>({
    query: FetchLineOfCreditHistoryDetails,
    variables: { lineOfCreditId: vlocId },
    requestPolicy: 'cache-and-network',
  });

  const { defaultTitle, defaultMessage, cancelButtonTitle } =
    useDefaultErrorStrings();

  const fetchHistoryDetails = useCallback(() => {
    executeQuery({ lineOfCreditId: vlocId });
  }, [executeQuery, vlocId]);

  const cancel = () => {
    router.back();
  };

  const buttons = {
    primaryButton: {
      title: cancelButtonTitle,
      onPress: cancel,
    },
  };

  const errorModel = error?.message
    ? {
        screenType: ErrorScreenType.Error,
        messageHeadline: defaultTitle,
        messageBody: error.message ?? defaultMessage,
        ...buttons,
      }
    : null;

  return {
    vlocData: data?.lineOfCreditHistoryDetails,
    errorModel: errorModel,
    loading: fetching,
    refetch: fetchHistoryDetails,
  };
};

export default useVlocHistoryDetails;
